<template>
    <div class="form-box">
        <el-form
            class="form__center"
            label-width="82px"
            size="small"
            style="margin-top: 30px;"
        >
            <el-form-item label="新密码：">
                <el-input
                    v-model="formItem.new_pass"
                    type="password"
                    show-password
                    placeholder="请输入新密码"
                />
            </el-form-item>
            <el-form-item label="确认密码：">
                <el-input
                    v-model="formItem.ck_pass"
                    type="password"
                    show-password
                    placeholder="请再次输入新密码"
                />
            </el-form-item>
            <el-form-item>
                <el-button
                    class="btn-standard"
                    type="primary"
                    @click="onSubmit"
                >
                    确认修改
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step2',
    data () {
        return {
            formItem: {
                new_pass: '',
                ck_pass: ''
            }
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.new_pass': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入新密码'
            },
            {
                test: /^[a-zA-Z0-9_-]{6,18}$/,
                message: '密码由6-18位的数字、字母和_组成'
            }
        ],
        'formItem.ck_pass': {
            test (val) {
                return val === this.formItem.new_pass
            },
            message: '两次输入的密码不一致'
        }
    },
    created () {
        if (JSON.stringify(this.$route.query) === '{}' || !this.$route.query.username) {
            this.$message.error('系统错误，请重试')
            router.replace('/account/home')
        } else {
            this.info = this.$route.query
        }
    },
    methods: {
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/findsetpwd', qs.stringify({
                    step: 2,
                    username: this.info.username,
                    new_pass: this.formItem.new_pass,
                    ck_pass: this.formItem.ck_pass
                })).then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: `新密码已生效。`
                        })
                        router.replace(`/account/entry/step3`)
                    }
                })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped>

</style>
